import { ChangeEvent, FocusEvent, useEffect, useRef } from 'react';

export const useOnType = (
	callbacks: {
		onChange: (value: string) => void;
		onBlur?: (value: string) => void;
		action: (formData: FormData) => void;
	},
	delay: number,
) => {
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
		undefined,
	);
	useEffect(() => {
		return () => {
			clearTimeout(timeoutRef.current);
		};
	}, []);

	const onChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.currentTarget.value;
		clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => {
			callbacks.onChange(value);
		}, delay);
	};
	const onBlur = (event: FocusEvent<HTMLInputElement>) => {
		if (callbacks.onBlur != null) {
			const value = event.currentTarget.value;
			clearTimeout(timeoutRef.current);
			callbacks.onBlur(value);
		}
	};
	const action = (formData: FormData) => {
		if (callbacks.action != null) {
			clearTimeout(timeoutRef.current);
			callbacks.action(formData);
		}
	};

	return {
		formProps: {
			action,
		},
		inputProps: {
			onChange,
			onBlur,
		},
	};
};
